import { createApp } from '@app/adapters/create-app'

import FirmDefaultPermanentCategories from '@app/firm-default-permanent-categories/components/permanent-categories'

onDomLoad(($dom) => {
  $dom
    .find("[data-behaviour='firm-default-permanent-categories']")
    .each(function () {
      const data = this.dataset

      createApp(FirmDefaultPermanentCategories, {
        firmId: parseInt(data.firmId),
        currentStructure: JSON.parse(data.currentStructure),
        ongoingImports: JSON.parse(data.ongoingImports),
        lastMessageBusId: data.lastMessageBusId,
      }).mount(this)
    })
})
